// @core/api/endpoints/task/list_task_types.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTaskTypesResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List task types
 * Returns all registered task types, optionally filtered by product.
 */
export async function ListTaskTypes(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTaskTypesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/task-types`;
  const requestOptions = options;
  return client.get<ListTaskTypesResponse>(requestPath, { ...requestOptions, params });
}
